export default __webpack_public_path__ + "app-config/initial-objects.xml";